export default __webpack_public_path__ + "static/media/logo-horizontal-color.7c87659c.svg";